<div class="p-3 mb-4 bg-light rounded-3">
    <!-- Header -->
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center">
                    <div class="leftsideicons">
                        <img src="../../assets/image/general-setting-icon.png" alt="generalsettingicon" />
                    </div>
                    <h3 class="mb-0">{{ "Maintenance" }}</h3>
                </div>
                <button type="button" class="btn btn-primary addBtn" (click)="openAddDialog()">
                    Add Maintenance
                </button>
            </div>
        </div>
    </div>

    <div class="grid-card">
        <app-data-grid>
        <!-- Grid -->
        <kendo-grid
            [data]="gridData"
            [pageSize]="pageSize"
            [skip]="skip"
            [pageable]="maintenanceList?.length > 0 ? pageableWithAll : false"
            (pageChange)="pageChange($event)"
            [sort]="sort"
            (sortChange)="sortChange($event)"
            [sortable]="{ mode: 'single' }"
            [groupable]="true"
            [group]="group"
            (groupChange)="groupChange($event)"
            [resizable]="true"
            [reorderable]="true">

        <!-- Action Column -->
        <kendo-grid-column field="Action" [width]="40" title=" " [includeInChooser]="false" [sortable]="false" [filterable]="false" [columnMenu]="false" [groupable]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="text-center">
                    <div class="mx-2 d-inline-block">
                        <button type="button" class="verical_menu" *ngIf="canEdit(dataItem)"
                            (click)="openEditDialog(dataItem)" matTooltip="Edit">
                            <kendo-svg-icon [icon]="icons.edit"></kendo-svg-icon>
                        </button>
                        <button type="button" class="verical_menu" (click)="openViewDialog(dataItem)" matTooltip="View">
                            <kendo-svg-icon [icon]="icons.view"></kendo-svg-icon>
                        </button>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>

        <!-- Message Column -->
        <kendo-grid-column field="MessageBox" title="Message" [width]="250">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [title]="dataItem.MessageBox">
                    {{ dataItem.MessageBox?.length > 60 ? dataItem.MessageBox.substring(0, 60) + '...' : dataItem.MessageBox }}
                </span>
            </ng-template>
        </kendo-grid-column>

        <!-- Start Date -->
        <kendo-grid-column field="StartDate" title="Start Date" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.StartDate | date:'dd/MM/yyyy' }}
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                Start Date: {{ value | date:'dd/MM/yyyy' }}
            </ng-template>
        </kendo-grid-column>

        <!-- Start Time -->
        <kendo-grid-column field="StartTime" title="Start Time" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ formatTime(dataItem.StartTime) }}
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                Start Time: {{ formatTime(value) }}
            </ng-template>
        </kendo-grid-column>

        <!-- End Date -->
        <kendo-grid-column field="EndDate" title="End Date" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.EndDate | date:'dd/MM/yyyy' }}
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                End Date: {{ value | date:'dd/MM/yyyy' }}
            </ng-template>
        </kendo-grid-column>

        <!-- End Time -->
        <kendo-grid-column field="EndTime" title="End Time" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ formatTime(dataItem.EndTime) }}
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                End Time: {{ formatTime(value) }}
            </ng-template>
        </kendo-grid-column>

        <!-- Maintenance Mode Column -->
        <kendo-grid-column field="IsActiveNow" title="Maintenance Mode" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [ngClass]="isActiveNow(dataItem) ? 'status-badge active' : 'status-badge inactive'">
                    {{ isActiveNow(dataItem) ? 'Active' : 'Inactive' }}
                </span>
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-value="value">
                Maintenance Mode: {{ value ? 'Active' : 'Inactive' }}
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
        </app-data-grid>
    </div>
</div>

<!-- Maintenance Add/View Dialog -->
<ng-template #maintenanceDialog>
    <div class="maintenance-dialog">
        <!-- Dialog Header -->
        <div class="modal-header dialog-header">
            <h4 class="popup-title">
                {{ dialogMode === 'add' ? 'Add Maintenance' : dialogMode === 'edit' ? 'Edit Maintenance' : 'Maintenance Details' }}
            </h4>
            <button type="button" class="btn-close" (click)="closeDialog()"></button>
        </div>

        <!-- Dialog Body -->
        <div class="modal-body mat-dialog-content dialog-body">

            <!-- ── VIEW MODE ── -->
            <ng-container *ngIf="dialogMode === 'view' && selectedItem">
                <div class="view-details">
                    <div class="view-row">
                        <div class="view-label">Message</div>
                        <div class="view-value message-value">{{ selectedItem.MessageBox }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">Start Date</div>
                        <div class="view-value">{{ selectedItem.StartDate | date:'dd/MM/yyyy' }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">Start Time</div>
                        <div class="view-value">{{ formatTime(selectedItem.StartTime) }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">End Date</div>
                        <div class="view-value">{{ selectedItem.EndDate | date:'dd/MM/yyyy' }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">End Time</div>
                        <div class="view-value">{{ formatTime(selectedItem.EndTime) }}</div>
                    </div>
                    <div class="view-row">
                        <div class="view-label">Maintenance Mode</div>
                        <div class="view-value">
                            <span [ngClass]="isActiveNow(selectedItem) ? 'status-badge active' : 'status-badge inactive'">
                                {{ isActiveNow(selectedItem) ? 'Active' : 'Inactive' }}
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- ── ADD / EDIT MODE ── -->
            <ng-container *ngIf="dialogMode === 'add' || dialogMode === 'edit'">
                <form [formGroup]="maintenanceForm" autocomplete="off">
                    <div class="row">
                        <!-- Message -->
                        <div class="col-12">
                            <label class="app-field-label">Message<span class="app-field-required">*</span></label>
                            <mat-form-field class="w-100 custom-blue">
                                <textarea matInput formControlName="message"
                                    placeholder="Enter maintenance message" rows="4" required></textarea>
                                <mat-error
                                    *ngIf="maintenanceForm.controls['message'].hasError('required') || maintenanceForm.get('message')?.errors?.['whitespace']">
                                    Message is required
                                </mat-error>
                                <mat-error
                                    *ngIf="maintenanceForm.controls['message'].value && maintenanceForm.controls['message'].value.trim().length === 0">
                                    Message cannot be empty or contain only white space.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Start Date & Time -->
                        <div class="row mt-2">
                            <div class="col-12 col-md-6">
                                <label class="dp-label">Start Date</label>
                                <app-date-picker formControlName="StartDate" [min]="isEditMode ? null : today"></app-date-picker>
                                <mat-error *ngIf="maintenanceForm.get('StartDate')?.touched && maintenanceForm.get('StartDate')?.invalid">
                                    <ng-container *ngIf="maintenanceForm.get('StartDate')?.errors?.['required']">
                                        Start date is required
                                    </ng-container>
                                    <ng-container *ngIf="maintenanceForm.get('StartDate')?.errors?.['pastDate']">
                                        Start date must be today or later
                                    </ng-container>
                                </mat-error>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <label class="floating-label">Start Time</label>
                                    <kendo-timepicker [format]="'HH:mm'" formControlName="startTime"
                                        required class="w-100 app-tp"></kendo-timepicker>
                                </div>
                            </div>
                        </div>

                        <!-- End Date & Time -->
                        <div class="row mt-3">
                            <div class="col-12 col-md-6">
                                <label class="dp-label">End Date</label>
                                <app-date-picker formControlName="EndDate" [min]="today"></app-date-picker>
                                <mat-error *ngIf="maintenanceForm.get('EndDate')?.touched && maintenanceForm.get('EndDate')?.invalid">
                                    <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['required']">
                                        End date is required
                                    </ng-container>
                                    <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['endBeforeStart']">
                                        End date cannot be earlier than start date
                                    </ng-container>
                                    <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['pastDate']">
                                        End date must be today or later
                                    </ng-container>
                                </mat-error>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="d-flex flex-column">
                                    <label class="floating-label">End Time</label>
                                    <kendo-timepicker [format]="'HH:mm'" formControlName="endTime"
                                        required class="w-100 app-tp"></kendo-timepicker>
                                </div>
                            </div>
                        </div>

                        <!-- Maintenance Toggle -->
                        <div class="col-12 mt-4">
                            <div class="d-flex align-items-center gap-2">
                                <mat-label>Maintenance Mode</mat-label>
                                <mat-slide-toggle formControlName="isMaintenance"
                                    (change)="openDialogRefforactive($event)"></mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
        </div>

        <!-- Dialog Footer -->
        <mat-dialog-actions align="end" class="dialog-footer">
            <button *ngIf="dialogMode === 'add' || dialogMode === 'edit'" mat-raised-button
                (click)="submit(maintenanceForm)" class="btn btn-primary me-2">
                {{ dialogMode === 'edit' ? 'Update' : 'Save' }}
            </button>
            <button mat-raised-button (click)="closeDialog()" class="btn btn-secondary">
                Close
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>
